import React, {useState} from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import classname from "classnames";
import "./index.css";

SelectPrice.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    amount_formatted: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

SelectPrice.defaultProps = {
    name: "radio",
    value: "value",
    label: "label",
    isSelected: false,
    amount_formatted: '£ 1.00/min',
    description: 'description'
}

function SelectPrice(props) {

    const [selected, setSelected] = useState(false);

    const container = classname("premium-content-modal-pricing-container", {
        "premium-content-modal-pricing-container-selected": props.isSelected
    })
    return (
        <div className={container}>
            <div className="premium-content-modal-pricing-container-row">
                <div>
                    <label className="custom-radio-btn-container">
                        <span className="premium-content-modal-pricing-title">{props.label}</span>
                        <input
                            type="radio"
                            name={props.name}
                            value={props.value}
                            checked={props.isSelected}
                            onChange={() => {
                                props.setPaymentChoice(props.value)
                            }}
                            onClick={() => {
                                props.setPaymentChoice(props.value)
                            }}
                        />
                        <span className="checkmark"></span>
                    </label>
                </div>
                <div className="premium-content-modal-pricing-amount">{props.amount_formatted}</div>
            </div>
            <div className="premium-content-modal-pricing-description">
                { parse(props.description)}
            </div>
        </div>
    );
}

export default SelectPrice;